import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, OnInit } from '@angular/core';

type Cols = number | string | any;

@Component({
  selector: 'crm-grid-col',
  template: '<ng-content></ng-content>',
  styleUrls: ['./grid-col.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridColComponent implements OnChanges {
  /**
   * @see https://github.com/rsms/raster Possible span values https://github.com/rsms/raster/blob/master/examples/columns.html
   */
  @Input() cols?: Cols;

  @HostBinding('attr.span') span: Cols;

  ngOnChanges() {
    this.setCols();
  }

  private setCols() {
    this.span = this.cols || 1;
  }
}
